export { default as EnSkeleton } from './EnSkeleton.vue';
export { default } from './EnSkeleton.vue';
